import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BreakpointObserverService {
  private breakpointObserver = inject(BreakpointObserver);

  public isSmallScreen$ = this.breakpointObserver.observe([Breakpoints.HandsetPortrait]).pipe(
    map((result: BreakpointState) => result.matches),
    shareReplay(1)
  );

  public isTabletScreen$ = this.breakpointObserver.observe([Breakpoints.TabletPortrait]).pipe(
    map((result: BreakpointState) => result.matches),
    shareReplay(1)
  );

  public isMediumScreen$ = this.breakpointObserver.observe([Breakpoints.Medium]).pipe(
    map((result: BreakpointState) => result.matches),
    shareReplay(1)
  );

  public isLargeScreen$ = this.breakpointObserver.observe([Breakpoints.Web]).pipe(
    map((result: BreakpointState) => result.matches),
    shareReplay(1)
  );

  public isSmallScreen = toSignal(this.isSmallScreen$, { initialValue: false });
  public isTabletScreen = toSignal(this.isTabletScreen$, { initialValue: false });
  public isMediumScreen = toSignal(this.isMediumScreen$, { initialValue: false });
  public isLargeScreen = toSignal(this.isLargeScreen$, { initialValue: false });
}
